module.exports = __webpack_public_path__ + "static/media/File.e14f51af.svg";